import template from './notifications.html';
import './notifications.css';

class NotificationsVM
{
	constructor (page)
	{
		this.page = page;
		this.sendouts = ko.observableArray([]);
		this.loading = ko.observable(true);
		this.total_count = ko.observable(0);

		this.current_page = ko.observable(1);
		this.page_size = ko.observable(25);
		this.page_count = ko.computed(() => Math.max(1, Math.ceil(this.total_count() / this.page_size())));

		this.filter_group = ko.observable('');
		this.filter_channel = ko.observable('');
		this.filter_seen = ko.observable('');
		this.available_groups = ko.observableArray([]);
		this.available_channels = ko.observableArray([]);

		this.current_page.subscribe(() => this.page.updateData());
		this.filter_seen.subscribe(() => { this.current_page(1); this.page.updateData(); });
	}

	async btnApplyFilters_click ()
	{
		this.current_page(1);
		await this.page.updateData();
	}

	async btnMarkSeen_click (sendout)
	{
		const result = await Grape.fetches.postJSON('/api/notifications/mark-seen', {
			notification_sendout_id: sendout.notification_sendout_id
		});
		if (result.status === 'OK')
			sendout._seen(true);
	}

	async btnMarkAllSeen_click ()
	{
		const result = await Grape.fetches.postJSON('/api/notifications/mark-seen', {
			mark_all: true
		});
		if (result.status === 'OK')
			await this.page.updateData();
	}

	btnPrevPage_click ()
	{
		if (this.current_page() > 1)
			this.current_page(this.current_page() - 1);
	}

	btnNextPage_click ()
	{
		if (this.current_page() < this.page_count())
			this.current_page(this.current_page() + 1);
	}
}

class NotificationsPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new NotificationsVM(this);
	}

	async init ()
	{
		const [channels_res] = await Promise.all([
			Grape.fetches.getJSON('/api/record', {
				schema: 'notifications',
				table: 'v_notification_channel'
			})
		]);
		this.viewModel.available_channels(channels_res.records || []);

		await this.updateData();
	}

	async updateData ()
	{
		this.viewModel.loading(true);

		try
		{
			const filter = [];

			const group_val = this.viewModel.filter_group();
			if (group_val)
				filter.push({ field: 'notification_group', operand: '=', value: group_val });

			const channel_val = this.viewModel.filter_channel();
			if (channel_val)
				filter.push({ field: 'channel_name', operand: '=', value: channel_val });

			const seen_val = this.viewModel.filter_seen();
			if (seen_val === 'unseen')
				filter.push({ field: 'date_seen', operand: 'IS NULL' });
			else if (seen_val === 'seen')
				filter.push({ field: 'date_seen', operand: 'IS NOT NULL' });

			const offset = (this.viewModel.current_page() - 1) * this.viewModel.page_size();

			const res = await Grape.fetches.getJSON('/api/record', {
				schema: 'notifications',
				table: 'v_notification_sendout',
				sortfield: 'date_inserted',
				sortorder: 'DESC',
				limit: this.viewModel.page_size(),
				offset: offset,
				filter: filter
			});

			const records = (res.records || []).map(r => {
				r._seen = ko.observable(!!r.date_seen);
				return r;
			});

			this.viewModel.sendouts(records);
			this.viewModel.total_count(res.total || records.length);

			const groups_set = new Set();
			for (const r of records)
			{
				if (r.notification_group)
					groups_set.add(r.notification_group);
			}
			const existing_groups = this.viewModel.available_groups().map(g => g);
			for (const g of groups_set)
			{
				if (!existing_groups.includes(g))
					existing_groups.push(g);
			}
			this.viewModel.available_groups(existing_groups.sort());
		}
		catch (err)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: err.message });
		}

		this.viewModel.loading(false);
	}
}

export default {
	route: '[/]ui/notifications',
	page_class: NotificationsPage,
	template: template
}
